import React from 'react'

const Bubble = ({name, position, handleSetOpen, isVisible}) => {
    const bubblePosition = position === 'top' ? 'top-0 left-0' : position === 'bottom' ? 'bottom-0 md:left-20 left-10' : 'top-1/4 right-0'
    const bubbleTransition = position === 'top' ? 'delay-[1000ms]' : position === 'bottom' ? 'delay-[1250ms]' : 'delay-[1500ms]'
    return (
        <div 
            className={`bg-[#fff] md:h-52 h-36 md:w-52 w-36 rounded-full flex justify-center items-center absolute z-10 group duration-500 ${bubblePosition} ${name} ${isVisible ? 'opacity-100' : 'opacity-0'} ${bubbleTransition}`}
            onClick={() => handleSetOpen(name)}
            onKeyPress={() => handleSetOpen(name)}
            role="button"
            tabIndex="0"
        >
            <h2 className="text-[#091DF3] md:text-[100px] text-[80px] tracking-[-0.04em]">{name}.</h2>
            <div className="md:h-9 h-7 md:w-9 w-7 bg-[#F9DFE8] rounded-full absolute md:top-3 top-0 md:right-[10px] right-2 flex justify-center items-center duration-300 group-hover:rotate-180 group-hover:scale-125">
                <div class="bg-[#091DF3] md:h-[20px] h-[16px] md:w-[3px] w-[3px] absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2"></div>
                <div class="bg-[#091DF3] md:h-[20px] h-[17px] md:w-[3px] w-[3px] absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 rotate-90"></div>
            </div>
        </div>
    )
}

export default Bubble